import { createAsyncThunk } from "@reduxjs/toolkit";
import { initiateResourceDetailsDrawerThunk } from "@/store/resource-details/thunks/initiateResourceDetailsDrawerThunk";
import { AllTypeResourceItem } from "@/store/resources-grid/utils/types/resources";
import { isResourceKubernetes } from "@/store/resources-grid/utils/helpers/isResourceKubernetes";
import { ResourceDetailsActiveTab } from "@/store/resource-details/utils/types/common";
import { RootState } from "@/store/store";
import { accountOrganisationIdSelector } from "@/store/accounts/selectors/slice-data/accountOrganisationIdSelector";
import { resourceTypesThatCanHaveCoverage } from "@/components/pages/common/resource-details/utils/constants/resourceTypesThatCanHaveCoverage";

export const setLiveUsageResourceDetailsDrawerResourceDataThunk =
  createAsyncThunk(
    "liveUsageMgmt/setLiveUsageResourceDetailsDrawerResourceData",
    async (resource: AllTypeResourceItem, { dispatch, getState }) => {
      if (!resource || isResourceKubernetes(resource)) {
        return;
      }

      const state = getState() as RootState;
      const providerOrgId = accountOrganisationIdSelector(state);

      const availableTabs: ResourceDetailsActiveTab[] = [
        "general",
        "costs",
        "metrics",
        "opportunities",
      ];

      if (
        ["aws", "azure"].includes(resource.account?.provider) &&
        resourceTypesThatCanHaveCoverage.has(resource.resource_type)
      ) {
        availableTabs.push("coverage");
      }

      const billingExplorerResourceIdentifier =
        resource.billing_explorer_resource_identifier ?? [
          resource.provider_unique_identifier,
        ];

      dispatch(
        initiateResourceDetailsDrawerThunk({
          openedFrom: "liveUsage",
          availableTabs,
          resource: {
            region: resource.region ?? "",
            provider_unique_identifier:
              resource.provider_unique_identifier ?? "",

            providerOrgId: providerOrgId,

            billing_explorer_resource_identifier:
              billingExplorerResourceIdentifier,

            name: (resource.name || resource.provider_unique_identifier) ?? "",

            resourceType: resource.resource_type,
            provider: resource.account?.provider,
            link: resource.link,
            providerAccountId: resource.account?.provider_account_id,
            providerAccountName: resource.account?.provider_account_name,
            accountId: resource.account?.id,
          },
          tags: { tags: resource.tags ?? [] },
          resourceAdditionalDetails: { resource },
        }),
      );
    },
  );
